import { Field } from "@progress/kendo-react-form";
import React, {  useEffect } from "react";
import { CusFormInput, CusFormInput2 } from "../validation/Form-Components";
import { blockValidator, boxNoValidator, buildingValidator, houseNoValidator, levelValidator, lockBagValidator, lotMukimValidator, postOfficeValidator, storeyValidator, streetValidator, unitNoValidator, winDeliValidator } from "../validation/Validators";

const LocalAddress = (props) => {

    const addTypeLocal= 'D',addTypeLockedBag='B',addTypeGodown='G';
    const addTypeMultiStorery='H',addTypeLotMukim='L',addTypePObox='P',addTypeHouseShopWalkupApmt='S',addTypeWindowDeli='W';

    const {id, addressType} = props;

    useEffect(() => {
        console.log('@LocalAddress useEffect');
 
    }, []);

    return (
        <div>
        {addressType !== null &&
        <div>
            {addressType === addTypeLocal &&
            <div>
                <Field component={CusFormInput} 
                    leftLabelId={'lblInputBlock'+id} 
                    leftLabelName={'Block Number'} 
                    placeholder={'eg. 1'} 
                    id={'sgBlkNo'} 
                    name={'sgBlkNo'} 
                    maxLength={10} 
                    validator={blockValidator} /> 
                                
                <Field component={CusFormInput} 
                    leftLabelId={'lblInputStreet'+id} 
                    leftLabelName={'Street Name'}  
                    placeholder={'eg. Ang Mo Kio Street 64'} 
                    id={'sgStreet'} 
                    name={'sgStreet'}
                    maxLength={66} 
                    validator={streetValidator} />
                                
                <Field component={CusFormInput} 
                    leftLabelId={'lblInputFlrNum'+id}  
                    leftLabelName={'Level'}  
                    placeholder={'eg. 03'} 
                    id={'sgStoreyNo'} 
                    name={'sgStoreyNo'}
                    maxLength={3}
                    validator={levelValidator} />
                                
                <Field component={CusFormInput} 
                    leftLabelId={'lblInputUno'+id} 
                    leftLabelName={'Unit Number'}  
                    id={'sgUnitNo'} 
                    name={'sgUnitNo'}  
                    placeholder={'eg. 01'} 
                    maxLength={6} 
                    validator={unitNoValidator} />

                <Field component={CusFormInput} 
                    leftLabelId={'lblInputBld'+id}  
                    leftLabelName={'Building Name'}  
                    id={'sgBuilding'} 
                    name={'sgBuilding'}  
                    placeholder={'eg. Maybank Centre'} 
                    maxLength={66} 
                    validator={buildingValidator} />
            </div>
            }
            {/* check addType Locked Bag Address. If addType is B, then show*/}
            {addressType === addTypeLockedBag &&
            <div>
                <Field component={CusFormInput2} 
                    leftLabelId={'lblInputPostOffice'+id} 
                    leftLabelName={'Post Office Name'}  
                    id={'sgPostOffice'} 
                    name={'sgPostOffice'} 
                    placeholder={'eg. SingPost'} 
                    maxLength={66} 
                    validator={postOfficeValidator} />

                <Field component={CusFormInput2} 
                    leftLabelId={'lblInputLockedBagNo'+id}  
                    leftLabelName={'Locked Bag Number'} 
                    id={'sgLockedBagNo'} 
                    name={'sgLockedBagNo'} 
                    placeholder={'eg. 54'} 
                    maxLength={10} 
                    validator={lockBagValidator} />

 
            </div>}

            {/* check addType Godown Address. If addType is G, then show*/}
            {addressType === addTypeGodown &&
            <div>        
                <Field component={CusFormInput2} 
                    leftLabelId={'lblInputBldName'+id}  
                    leftLabelName={'Building Name'} 
                    id={'sgBuilding'} 
                    name={'sgBuilding'} 
                    placeholder={'eg. TRADEHUB 21'} 
                    maxLength={66} />

                <Field component={CusFormInput2} 
                    leftLabelId={'lblInputStoreyNo'+id}  
                    leftLabelName={'Level'}
                    id={'sgStoreyNo'} 
                    name={'sgStoreyNo'} 
                    placeholder={'eg. 03'} 
                    maxLength={3} />

                <Field component={CusFormInput2} 
                    leftLabelId={'lblInputUnitNo'+id} 
                    leftLabelName={'Unit Number'} 
                    id={'sgUnitNo'} 
                    name={'sgUnitNo'} 
                    placeholder={'eg. 18'} 
                    maxLength={6}  />

                <Field component={CusFormInput2} 
                    leftLabelId={'lblInputStreet'+id}  
                    leftLabelName={'Street Name'} 
                    id={'sgStreet'} 
                    name={'sgStreet'} 
                    placeholder={'eg. BOON LAY WAY'} 
                    maxLength={66}  />

                <Field component={CusFormInput2} 
                    leftLabelId={'lblInputGodownNo'+id}  
                    leftLabelName={'Godown Number'} 
                    id={'sgGodownNo'} 
                    name={'sgGodownNo'}
                    placeholder={'eg. 18'} 
                    maxLength={6}  />
            </div>}

            {/* check addType Lot / Mukim Address. If addType is L, then show*/}
            {addressType === addTypeLotMukim &&
            <div>
                <Field component={CusFormInput2} 
                    leftLabelId={'lblInputStreet'} 
                    leftLabelName={'Street Name'} 
                    id={'sgStreet'} 
                    name={'sgStreet'} 
                    placeholder={'Enter input'} 
                    maxLength={66} 
                    validator={streetValidator} />

                <Field component={CusFormInput2} 
                    leftLabelId={'lblInputLot_Mukim_Number'+id}  
                    leftLabelName={'Lot/Mukim Number'}  
                    id={'sgLotMukimNo'} 
                    name={'sgLotMukimNo'} 
                    placeholder={'Enter input'} 
                    maxLength={6} 
                    validator={lotMukimValidator} />
            </div>}

             {/* check addType House, Shop , Walkup Apartment. If addType is S, then show*/}
             {addressType === addTypeHouseShopWalkupApmt &&
            <div> 
                <Field component={CusFormInput2} 
                    leftLabelId={'lblInputBldName'+id}  
                    leftLabelName={'Building Name'}  
                    id={'sgBuilding'} 
                    name={'sgBuilding'} 
                    placeholder={'eg. Maybank Centre'} 
                    maxLength={66}   />

                <Field component={CusFormInput2} 
                    leftLabelId={'lblInputHouseNo'+id} 
                    leftLabelName={'House Number'}
                    id={'sgHouseNo'} 
                    name={'sgHouseNo'} 
                    placeholder={'eg. 1'} 
                    maxLength={6} 
                    validator={houseNoValidator} />
                                
                <Field component={CusFormInput2} 
                    leftLabelId={'lblInputStreet'+id}  
                    leftLabelName={'Street Name'}
                    id={'sgStreet'} 
                    name={'sgStreet'} 
                    placeholder={'eg. Ang Mo Kio Street 64'} 
                    maxLength={66} 
                    validator={streetValidator} />
                             
            </div> }

            {/* check addType Multi-Storery Address. If addType is H, then show*/}
            {addressType === addTypeMultiStorery &&
            <div>
                <Field component={CusFormInput2} 
                    leftLabelId={'lblInputBlock'+id}  
                    leftLabelName={'Block Number'}
                    placeholder={'eg. 1'} 
                    id={'sgBlkNo'} 
                    name={'sgBlkNo'} 
                    maxLength={10} 
                    validator={blockValidator} /> 
                
                <Field component={CusFormInput2} 
                    leftLabelId={'lblInputBldName'+id}  
                    leftLabelName={'Building Name'}
                    id={'sgBuilding'} 
                    name={'sgBuilding'} 
                    placeholder={'eg. Maybank Centre'} 
                    maxLength={66} />
                                
                <Field component={CusFormInput2} 
                    leftLabelId={'lblInputStoreyNo'+id}  
                    leftLabelName={'Level'}
                    id={'sgStoreyNo'} 
                    name={'sgStoreyNo'} 
                    placeholder={'eg. 03'} 
                    maxLength={3} 
                    validator={storeyValidator}
                    />
                                
                <Field component={CusFormInput} 
                    leftLabelId={'lblInputUno'+id}  
                    leftLabelName={'Unit Number'}
                    id={'sgUnitNo'} 
                    name={'sgUnitNo'}  
                    placeholder={'eg. 02'} 
                    maxLength={6} 
                    validator={unitNoValidator} />

                <Field component={CusFormInput2} 
                    leftLabelId={'lblInputStreet'+id}  
                    leftLabelName={'Street Name'}
                    id={'sgStreet'} 
                    name={'sgStreet'} 
                    placeholder={'eg. Ang Mo Kio Street 64'} 
                    maxLength={66} 
                    validator={streetValidator} />
            </div>
            }

             {/* check addType P.O. Box Address. If addType is P, then show*/}
             {addressType === addTypePObox &&
            <div>
                <Field component={CusFormInput2} 
                    leftLabelId={'lblInputBoxNo'+id} 
                    leftLabelName={'Box Number'}
                    id={'sgBoxNo'} 
                    name={'sgBoxNo'}  
                    placeholder={'Enter input'} 
                    maxLength={10} 
                    validator={boxNoValidator} />

                <Field component={CusFormInput2} 
                    leftLabelId={'lblInputPostOffice'} 
                    leftLabelName={'Post Office Name'}
                    id={'sgPostOffice'} 
                    name={'sgPostOffice'} 
                    placeholder={'Enter input'} 
                    maxLength={66} 
                    validator={postOfficeValidator} />
  
            </div>}

            {/* check addType Window Delivery Address. If addType is W, then show*/}
            {addressType === addTypeWindowDeli &&
            <div>
                <Field component={CusFormInput2} 
                    leftLabelId={'lblInputWinDeliNo'}  
                    leftLabelName={'Window Delivery Number'}
                    id={'sgWindowDeliveryNo'} 
                    name={'sgWindowDeliveryNo'} 
                    placeholder={'Enter input'} 
                    maxLength={6} 
                    validator={winDeliValidator} />

                <Field component={CusFormInput2} 
                    leftLabelId={'lblInputPostOffice'} 
                    leftLabelName={'Post Office Name'}
                    id={'sgPostOffice'} 
                    name={'sgPostOffice'} 
                    placeholder={'Enter input'} 
                    maxLength={66} 
                    validator={postOfficeValidator} />
            </div>
            }
        
            {/* <Field
                  component={CusFormInput}
                  leftLabelId={"lblStateCity"+id}
                  leftLabelName={"State/City"}
                  id={id+"StateCity"}
                  name={id+"StateCity"}
                  disabled={true}
                  placeholder={'SINGAPORE'}
            />
            <Field
                  component={CusFormInput}
                  leftLabelId={"lblCountry"+id}
                  leftLabelName={"Country"}
                  id={id+"Country"}
                  name={id+"Country"}
                  disabled={true}
                  placeholder={'SINGAPORE'}
            /> */}
        </div>
        }
    </div>
    )
}

export default LocalAddress;